<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <el-form id="elForm" :model="queryForm" ref="queryForm" :inline="true" class="demo-form-inline" label-width="85px" size="medium">
                        <el-form-item label="上报时间：" prop="date" >
                            <!-- <el-date-picker v-model="queryForm.date" :default-value="queryForm.date" startKey="startDate" endKey="endDate" type="daterange" align="right" placeholder="选择日期范围" :picker-options="pickerOptions" ></el-date-picker> -->
                            <double-date v-model="queryForm.date" :modelData="queryForm.date" modelKey="date" :data="queryForm" startKey="startDate" endKey="endDate"></double-date> 
                        </el-form-item>
                        <el-form-item label="报表名称：">
                            <el-input v-model="queryForm.contents"></el-input>
                        </el-form-item>
                        <el-form-item label="幼儿园：">
                            <el-select v-model="queryForm.kindName" @visible-change="changeType()" filterable>
                                <el-option v-for="item in kindPro" :key="item.orgID" :label="item.kindName" :value="item.orgID"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="状态：" >
                            <el-select v-model="queryForm.status">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="未读" value="1"></el-option>
                                <el-option label="已读" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="btn-primary" @click="query">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 操作按钮 -->
                        <div class="mb15">
                            <el-button-group>
                                <el-button style="border-radius:6px;" @click="opederive()"><i class="el-icon-download"></i>&nbsp;导出</el-button>
                            </el-button-group>
                        </div>
                        <!-- 用户列表-->
                        <template>
                            <el-table :data="tableData" class="table-bordered"  style="width: 100%">
                                <el-table-column type="selection" current-row-key="reportID" width="55"></el-table-column>
                                <el-table-column prop="reportTime" label="上报时间" show-overflow-tooltip ></el-table-column>
                                <el-table-column prop="contents" label="上报内容" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="kindName" label="幼儿园" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="statusName" label="状态"></el-table-column>
                                <el-table-column label="操作"> 
                                    <template slot-scope="scope">
                                       <el-button class="btn-warning btn-outline" @click="reportDetail(scope.$index,scope.row)" size="small" plain><i class="el-icon-document"></i>详情</el-button>
                                    </template>
                                 </el-table-column>
                            </el-table>
                        </template>
                        <!--分页-->
                        <el-pagination :current-page.sync="queryForm.page" :page-sizes="[10, 20, 50, 100]" :page-size="queryForm.pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="total_rows"
                            @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top: 10px;">
                        </el-pagination>
                    </div>
            </div>
        </div>
    <!--彈出的添加-->
    <el-dialog  :visible.sync="dialogTableVisible" :close-on-click-modal='false'>
        <router-view v-on:close="close"></router-view>
    </el-dialog>
</div>

</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import DoubleDate from '@/components/utils/DoubleDate.vue'

export default {

  name: 'app',
  data () {
    let that = this

    return {
            // 对象属性
        queryForm: {
            date: '',
            contents: '',
            kindName: '',
            status: ''
          },
        tableData: [],
        kindPro: [], // 幼儿园数据
        formInline: {},
        dialogTableVisible: false,
        pickerOptions: {
            shortcuts: [{
                text: '全部',
                onClick (picker) {
                    const end = that.queryParam.endDate
                    const start = that.queryParam.startDate
                    picker.$emit('pick', [start, end])
                  }
              }, {
                  text: '过去七天',
                  onClick (picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                  }
                }, {
                  text: '过去30天',
                  onClick (picker) {
                    const end = new Date()
                    const start = that.GetMonthStr(1)
                        //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end])
                  }
                }, {
                  text: '过去半年',
                  onClick (picker) {
                    const end = new Date()
                    const start = that.GetMonthStr(6)
                        //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end])
                  }
                }, {
                  text: '过去一年',
                  onClick (picker) {
                    const end = new Date()
                    const start = that.GetMonthStr(12)
                    picker.$emit('pick', [start, end])
                  }
                }]
          }
      }
  },
  methods: {
    close (flag) { // 为子组件的返回($emit)按钮定义的事件
        this.dialogTableVisible = flag
      },
    pageSizeChange (val) { // 每页显示条数
        this.queryForm.pageSize = val

        this.queryForm.keyWord = this.keyWord

        this.getReports(this.queryForm)
      },
    pageCurrentChange (val) { // 分页
        this.queryForm.pageNum = val

        this.queryForm.keyWord = this.keyWord

        this.getReports(this.queryForm)
      },
    query (param) { // 查询按钮
        this.queryForm.keyWord = this.keyWord

        this.getReports(this.queryForm)
      },
    GetMonthStr (AddMonthCount) { // 获取过去几个月
        var dd = new Date()
        dd.setMonth(dd.getMonth() - AddMonthCount)// 获取AddMonthCount月后的日期
        var y = dd.getFullYear()
        var m = dd.getMonth() + 1// 获取当前月份的日期
        var d = dd.getDate()
            // 判断 月
        if (m < 10) {
              m = '0' + m
            } else {
              m = m
            }
            // 判断 日n
        if (d < 10) { // 如果天数<10
            d = '0' + d
          } else {
            d = d
          }
        return y + '-' + m + '-' + d
      },
    changeType () { // 获取幼儿园接口的数据
        api.post(config.host + 'report/getKindName.do').then((data) => {
            if (data.success == true) {
                this.kindPro = data.body.list
              }
          })
      },
    getReports (pram) {
        this.formInline.status = pram.status
        this.formInline.startDate = pram.startDate
        this.formInline.endDate = pram.endDate
        this.formInline.contents = pram.contents
        this.formInline.kindName = pram.kindName
        api.post('report/getRecReportList.do', this.formInline).then((data) => {
            // api.post('report/getRecReportList.do', pram).then((data) => {

              if (data.success == true) {
                this.queryForm.keyWord = this.keyWord

                this.tableData = data.body.list

                this.total_rows = data.body.page.total
              }
            })
      },
    downloadXls (url, pojo, filename) { // 封装好的导出函数
        var xhr = new XMLHttpRequest()
        xhr.open('POST', url, true)
        xhr.responseType = 'arraybuffer'
        xhr.onload = function () {
              if (this.status === 200) {
                var type = xhr.getResponseHeader('Content-Type')
                var blob = new Blob([this.response], {
                      type: type
                    })
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                      filename += '.xls'
                      window.navigator.msSaveBlob(blob, filename)
                    } else {
                      var URL = window.URL || window.webkitURL
                      var downloadUrl = URL.createObjectURL(blob)
                      if (filename) {
                            // use HTML5 a[download] attribute to specify filename
                          var a = document.createElement('a')
                            // safari doesn't support this yet
                          if (typeof a.download === 'undefined') {
                              window.location = downloadUrl
                            } else {
                              a.href = downloadUrl
                              a.download = filename + '.xls'
                              document.body.appendChild(a)
                              a.click()
                            }
                        } else {
                          window.location = downloadUrl
                        }
                      setTimeout(function () {
                        URL.revokeObjectURL(downloadUrl)
                      },
                            100) // cleanup
                    }
              }
            }
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.setRequestHeader('Haiziguo-Token', localStorage.getItem('Haiziguo-Token'))
        xhr.send(pojo)
      },
    opederive () { // 导出按钮
        var mydate = new Date()
        var str = '' + mydate.getFullYear() + '-'
          str += (mydate.getMonth() + 1) + '-'
          str += mydate.getDate()
        var name = '报表上报记录查询（' + str + '）'
          var parm = JSON.stringify(this.queryForm)
        this.downloadXls(config.host + 'report/exportReportDetailFromKhsExcel.do', parm, name)
      },
    reportDetail (index, row) { // 详情
        this.dialogTableVisible = true
        this.$router.push({path: '/reportUpload/uploadDetails/' + row.reportID })
      }

  },
  components: {// 日期控件的通用函数

    doubleDate: DoubleDate

  },
  created: function () {
    if (this.kindName != undefined || this.kindName != null) {
        this.kindName = window.localStorage.getItem('kindName')// 从报表上报页到这里
      } else {
        this.kindName = ''
        }

    api.post(config.host + 'report/getRecReportList.do', { 'pageNum': 1, 'pageSize': 10, 'kindName': this.kindName }).then((data) => {
        if (data.success == true) {
            this.tableData = data.body.list

            this.total_rows = data.body.page.total
          }
      })
  }

}
</script>
<style>
.el-table th{
    background:#F5F5F5 !important;
    font-size:15px;
} 


</style>


// WEBPACK FOOTER //
// src/components/reports/reportUpload.vue?822842f8